import React, { useEffect, useState } from 'react'
import './StickyAd.css'

import knapperAd from '../../images/ads/stickyKnapperAd.png'

const StickyAd = ({ isInApp }) => {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 440)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		window.addEventListener('resize', handleResize)

		return () => window.removeEventListener('resize', handleResize)
	}, [])
	//
	//
	//
	//
	useEffect(() => {
		if (!isMobile || isInApp) {
			document.body.classList.remove('hasStickyAd')
			return
		}

		document.body.classList.add('hasStickyAd')

		return () => {
			document.body.classList.remove('hasStickyAd')
		}
	}, [isMobile, isInApp])
	//
	//
	//
	//
	if (!isMobile || isInApp) {
		return null
	}

	return (
		<div className='stickyAd'>
			<a href='https://knapper.com' target='_blank' rel='noopener noreferrer'>
				<img src={knapperAd} alt='Knapper' className='stickyAdImage' />
			</a>
		</div>
	)
}

export default StickyAd
